import { createFileRoute } from "@tanstack/react-router";

import { PreferencesContainer } from "@/features/settings/containers/preferences-container";

export const Route = createFileRoute("/settings/preferences")({
  component: PreferencesContainer,
});
